export const getSchedule = (props) => {
    fetch("/schedule?organization=" + encodeURIComponent(props.organization) + (props.deep ? "&deep=" + encodeURIComponent(props.deep) : ''), {
        method: 'GET',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    })
        .then(res => res.json())
        .then(answer => {
            props.setSchedule({ schedule: answer.state, loading: false, organization: answer.organization, organizationShortName: answer.organizationShortName });
            let sessionTypesList = answer.tSesList;
            sessionTypesList.unshift(
                {
                    "pers" : "all",
                    "title" : "Все",
                    "description" : "Отображать все записи"
                },
                {
                    "pers" : "all-detail",
                    "title" : "Все подробно",
                    "description" : "Отображать все записи"
                }
            );
            props.setTSesList(sessionTypesList);
            props.setOrganizationList(answer.organizationsList);
        })
        .catch(err => {
            console.log(err)
        });
};
